import AldeliaImage from '../../assets/Images/Logos/AldeliaLogo.png';
import ATRImage from '../../assets/Images/Logos/ATRLogo.png';
import BuckheadImage from '../../assets/Images/Logos/BuckHeadLogo.png';
import CanalPlus from '../../assets/Images/Logos/CanalLogo.png';
import GIZImage from '../../assets/Images/Logos/GizLogo.png';
import HamiltonCrescentImage from '../../assets/Images/Logos/HamiltonLogo.png';
import KeplerImage from '../../assets/Images/Logos/KeplerLogo.png';
import MasterNodedImage from '../../assets/Images/Logos/MasterNodedLogo.png';
import WatchReportImage from '../../assets/Images/Logos/WatchReportLogo.png';
import YellowCardImage from '../../assets/Images/Logos/WatchReportLogo.png';

const RecentProjectData = [
  {
    image: GIZImage,
    alt: 'GIZ office building with people walking outside, modern architecture',
    title: 'GIZ',
    link: 'https://www.giz.de/en/html/index.html',
  },
  {
    image: CanalPlus,
    alt: 'Canal Plus promotional image featuring a man with a crowd in the background.',
    title: 'Canal Plus',
    link: 'https://www.canalplus.com/ ',
  },
  {
    image: HamiltonCrescentImage,
    alt: 'Hamilton Crescent ad promoting financial freedom with a city skyline image',
    title: 'Hamilton Crescent',
    link: 'https://hamiltonccm.com',
  },
  {
    image: AldeliaImage,
    alt: 'Aldelia ad featuring a smiling woman in a headscarf, bridging talent and industries',
    title: 'Aldelia',
    link: 'https://www.aldelia.com/en/',
  },
  {
    image: ATRImage,
    alt: '',
    title: 'ATR Cyber',
    link: 'https://atrcyber.com',
  },
  {
    image: WatchReportImage,
    alt: '',
    title: 'Watch Report',
    link: 'https://www.watchreport.com',
  },
  {
    image: YellowCardImage,
    alt: '',
    title: 'Yellow Card',
    link: 'https://yellowcard.io/',
  },
  {
    image: MasterNodedImage,
    alt: '',
    title: 'Masternoded',
    link: 'https://masternoded.com',
  },
  {
    image: BuckheadImage,
    alt: '',
    title: 'Buckhead',
    link: 'https://www.buckhead.com/',
  },
  { image: KeplerImage, alt: '', title: 'Kepler', link: 'https://kepler.org' },
];

export default RecentProjectData;
